import React, { useState } from "react";
import {
  Button,
  Slider,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  CircularProgress,
  Tooltip,
} from "@mui/material";

export default function PeerReport({ rankingsLength, onGenerate }) {
  const [open, setOpen] = useState(false);
  const [topK, setTopK] = useState(5);
  const [loading, setLoading] = useState(false);

  const handleOpenDialog = () => {
    setOpen(true);
  };

  const handleCloseDialog = () => {
    setOpen(false);
  };

  const handleSliderChange = (event, newValue) => {
    setTopK(newValue);
  };

  const handleGenerateClick = () => {
    setLoading(true);
    console.log("Generating top", topK);
    onGenerate(topK); // Pass the slider value to the parent
    setLoading(false);
    handleCloseDialog();
  };

  return (
    <>
      <Tooltip
        title="Generate Peer-to-Peer Rankings"
        arrow
        placement="right"
      >
        <Button variant="contained" color="primary" onClick={handleOpenDialog}>
          Peer Rankings
        </Button>
      </Tooltip>

      <Dialog
        open={open}
        onClose={handleCloseDialog}
        fullWidth
        sx={{
          "& .MuiDialog-paper": {
            borderRadius: "12px", 
            border: "1px solid rgba(0, 0, 0, 0.1)", 
          },
        }}
      >
        <DialogTitle>Generate Peer Rankings</DialogTitle>
        <DialogContent>
          <Typography
            variant="subtitle1"
            gutterBottom
            sx={{
              fontWeight: "bold",
              color: "text.secondary",
              marginBottom: "16px",
            }}
          >
            Select the Number of Candidates for Ranking
          </Typography>
          <Slider
            value={topK}
            onChange={handleSliderChange}
            min={1}
            max={rankingsLength}
            step={1}
            valueLabelDisplay="auto"
            sx={{ color: "primary.main" }}
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleCloseDialog}
            color="inherit"
            variant="outlined"
          >
            Cancel
          </Button>
          <Button
            onClick={handleGenerateClick}
            variant="contained"
            color="primary"
            disabled={loading}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              ...(loading && {
                backgroundColor: "primary.light",
                animation: "pulse 1.5s infinite",
                "@keyframes pulse": {
                  "0%": { opacity: 1 },
                  "50%": { opacity: 0.6 },
                  "100%": { opacity: 1 },
                },
              }),
            }}
          >
            {loading ? (
              <>
                <CircularProgress size={20} sx={{ color: "white" }} />
                Generating...
              </>
            ) : (
              "Generate"
            )}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
